export default class Flyout {
	constructor() {
		this.node = document.querySelector(".nav--primary");

		if (!this.node) {
			return;
		}

		this.classes = {
			bodyOpened: "fixed",
			contentOpened: "nav__content--opened",
			menuOpened: "nav__menu-sub--opened",
			opened: "nav--opened",
			toggleActive: "toggle-btn--menu--active",
			navHasToggleActive: "nav__menu--has-toggle-active",
		};

		this.toggleMenu = this.node.querySelector(".toggle-btn--menu");
		this.content = this.node.querySelector(".nav__content");
		this.nav = this.node.querySelector(".nav__menu");
		this.backs = this.node.querySelectorAll(".nav__menu-return");
		this.toggles = this.node.querySelectorAll(".nav__menu-toggle");

		this.modes = ["menu"];
		this.setMode("menu");

		if (this.toggleMenu) {
			this.toggleMenu.addEventListener("click", () => {
				if (this.node.classList.contains(this.classes.opened)) {
					// close
					this.close();
				} else {
					// open
					this.open("menu");
				}
			});
		}

		//search close .site-search site-search--opened
		document.querySelector(".site-search").addEventListener("click", () => {
			if (this.node.classList.contains(this.classes.opened)) {
				// close
				this.close();
				document.body.classList.add(this.classes.bodyOpened);
			}
		});

		// handle esc/tab keys
		this.handleKeyup = (e) => {
			if (this.opened) {
				if (e.key === "Escape") {
					return this.close();
				}

				if (
					e.key === "Tab" &&
					!document.activeElement.closest(".nav--primary")
				) {
					// close the flyout when you tab out of it (if possible)
					return this.close();
				}
			}
		};

		// handle close
		this.node.addEventListener("click", (e) => {
			if (e.target.closest(".nav--primary")) {
				return;
			}

			this.close();
		});

		const openSubmenu = (navItem) => {
			if (!navItem) {
				return;
			}
			const submenu = navItem.querySelector(".nav__menu-sub");
			const toggle = navItem.querySelector(".nav__menu-toggle");

			if (document.body.clientWidth >= 992) {
				document.body.classList.add(this.classes.bodyOpened);
			}

			this.nav.classList.add(this.classes.navHasToggleActive);
			toggle.classList.add(this.classes.toggleActive);
			submenu.classList.add(this.classes.menuOpened);
			submenu.style.height = `${submenu.scrollHeight}px`;

			submenu.querySelectorAll("a, button").forEach((node) => {
				if (node.dataset.tabIndex) {
					node.tabIndex = node.dataset.tabIndex;
				}
			});

			this.content.scrollTo(0, 0);
		};

		const closeSubmenu = (navItem) => {
			if (!navItem) {
				return;
			}
			console.log("close");
			const submenu = navItem.querySelector(".nav__menu-sub");
			const toggle = navItem.querySelector(".nav__menu-toggle");

			if (document.body.clientWidth >= 992) {
				document.body.classList.remove(this.classes.bodyOpened);
			}

			this.nav.classList.remove(this.classes.navHasToggleActive);
			console.log(this.nav);
			toggle.classList.remove(this.classes.toggleActive);
			submenu.classList.remove(this.classes.menuOpened);
			submenu.style.height = "";

			submenu.querySelectorAll("a, button").forEach((node) => {
				node.tabIndex = -1;
			});

			this.content.scrollTo(0, 0);
		};

		this.node
			.querySelectorAll(".nav__menu-sub a, .nav__menu-sub button")
			.forEach((node) => {
				node.dataset.tabIndex = node.tabIndex;
				node.tabIndex = -1;
			});

		this.backs.forEach((back) => {
			back.addEventListener("click", () =>
				closeSubmenu(back.closest(".nav__menu-item"))
			);
		});

		this.toggles.forEach((toggle) => {
			toggle.addEventListener("click", () => {
				const item = toggle.closest(".nav__menu-item");

				if (toggle.classList.contains(this.classes.toggleActive)) {
					// close
					closeSubmenu(item);
				} else {
					// open
					openSubmenu(item);
				}
			});
		});
	}

	open(mode) {
		this.opened = true;
		this.node.style.display = "block";
		document.body.classList.add(this.classes.bodyOpened);
		document.addEventListener("keyup", this.handleKeyup);

		this.disableTabs();

		this.previousActiveElement = document.activeElement;

		requestAnimationFrame(() =>
			requestAnimationFrame(() => {
				this.node.classList.add(this.classes.opened);
				this.content.classList.add(this.classes.contentOpened);

				// if (this.mode === 'search' && this.searchInput) {
				// 	this.searchInput.focus();
				// } else
				// if ( this.closer ) {
				// 	this.closer.focus();
				// }

				this.node.dispatchEvent(
					new CustomEvent("flyout:open", { bubbles: true, cancelable: false })
				);
			})
		);
	}

	close() {
		this.opened = false;
		document.removeEventListener("keyup", this.handleKeyup);

		const onTransitionEnd = (e) => {
			this.content.removeEventListener("transitionend", onTransitionEnd);

			this.node.style.display = "";
			if (
				!document
					.querySelector(".site-search")
					.classList.contains("site-search--opened")
			) {
				document.body.classList.remove(this.classes.bodyOpened);
			}

			this.node.classList.remove(this.classes.opened);

			if (this.previousActiveElement) {
				this.previousActiveElement.focus();
			}

			this.enableTabs();

			this.node.dispatchEvent(
				new CustomEvent("flyout:close", { bubbles: true, cancelable: false })
			);
		};

		this.content.addEventListener("transitionend", onTransitionEnd);
		this.content.classList.remove(this.classes.contentOpened);
	}

	setMode(mode = "menu") {
		this.mode = mode;

		this.modes.forEach((m) => {
			if (mode === m) {
				this.node.classList.add(`flyout--${m}`);
			} else {
				this.node.classList.remove(`flyout--${m}`);
			}
		});

		return this.mode;
	}

	getTabs(scope = document) {
		return Array.from(
			scope.querySelectorAll(
				[
					"select",
					"input",
					"textarea",
					"button",
					"a",
					"iframe",
					"object",
					"embed",
					"*[contenteditable]",
					"*[tabindex]",
				].join(", ")
			)
		).filter((node) => {
			return !node.closest(".nav--primary");
		});
	}

	disableTabs() {
		const tabs = this.getTabs();

		tabs.forEach((node) => {
			let prevTabIndex = node.getAttribute("tabIndex");
			if (prevTabIndex) {
				node.setAttribute("data-tab-index", prevTabIndex);
			}

			node.setAttribute("tabIndex", "-1");
		});

		return tabs;
	}

	enableTabs() {
		const tabs = this.getTabs();

		tabs.forEach((node) => {
			let prevTabIndex = node.getAttribute("data-tab-index");
			if (prevTabIndex) {
				node.setAttribute("tabIndex", prevTabIndex);
				node.removeAttribute("data-tab-index");
			} else {
				node.removeAttribute("tabIndex");
			}
		});

		return tabs;
	}
}
